import { useState, useRef, useEffect, useContext } from "react";
import axios from "axios";

import {
  Plus,
  Edit2,
  Trash2,
  ChevronDown,
  Check,
  Search,
  ImageOff,
} from "lucide-react";
import AddCategory from "../../../subscreen/admin/addCategory/AddCategory";
import EditCategory from "../../../subscreen/admin/editCategory/EditCategory";
import DeleteCategoryConfirmation from "../../../subscreen/admin/deleteCategoryConfirmation/DeleteCategoryConfirmation";
import "../../../assets/css/admin/admincategorylist/AdminCategoryList.css";
import AppContext from "../../../context/AppContext";

const AdminCategoryList = () => {

  const [isAddOpen, setIsAddOpen] = useState(false);
  const [editId, setEditId] = useState(null);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [categories, setCategories] = useState([]);
  const {baseUrl,baseUrlForFile, authToken} = useContext(AppContext);
  const [refresh, setRefresh]= useState(false);

const viewAlladCategories = ()=>{
  axios.get(`${baseUrl}/admin/category/viewCategories`,
 {
   headers:{
      Authorization:`Bearer ${authToken}`,
      "content-Type" : "multipart/form-data"
    }
 }).then((response)=>{
    setCategories(response.data.categories);
  }).catch((error)=>{
    console.error("Error fetching categories:", error);
  });
};

useEffect(() => {
  viewAlladCategories();
},[refresh]);

const handleEdit = (updatedCategory) => {

  setCategories((prev) =>
    prev.map((cat) =>
      cat.id === updatedCategory.id
        ? updatedCategory
        : cat
    )
  );

};

const handledelete = () => {
    console.log("******");
    console.log(deleteTarget.id);
    console.log("******");
    setIsDeleting(true);
    const formData = new FormData();
    formData.append("id", deleteTarget.id);
    axios.post(`${baseUrl}/admin/category/deleteCategory`, formData, {
    headers: {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "multipart-formdata"    
    }
}).then((response)=>{
    console.log(response.data);
    setCategories((prev) => prev.filter((cat) => cat.id !== deleteTarget.id));
    setDeleteTarget(null);
    setIsDeleting(false);   

}).catch((error)=>{
    console.log(error);
    setIsDeleting(false);
});    
}


  return (
    <div className="cat-container">
      {/* ── Header ── */}
      <div className="cat-header">
        <div>
          <h1 className="cat-title">Category List</h1>
          <p className="cat-subtitle">
            Manage and organise your product categories
          </p>
        </div>
        <button className="cat-add-btn" onClick={() => setIsAddOpen(true)}>
          <Plus size={16} /> Add Category
        </button>
      </div>

      {/* ── Controls: Search + Filter ── */}
      <div className="cat-controls">
        <div className="cat-search">
          <Search size={15} className="cat-search-icon" />
          <input
            type="text"
            className="cat-search-input"
            placeholder="Search by name or description..."
          />
        </div>
       
      </div>

      {/* ── Table ── */}
      <div className="cat-table-container">
  {categories.length === 0 ? (
    <div className="cat-empty-state">
      <div className="cat-empty-icon">📦</div>
      <h3>No categories found</h3>
      <p>Try adjusting your search or filter</p>
    </div>
  ) : (
    <table className="cat-table">
      <thead>
        <tr>
          <th>Image</th>
          <th>Category Name</th>
          <th>Description</th>
          <th>Products</th>
          <th>Type</th>
          <th>Actions</th>
        </tr>
      </thead>

      <tbody>
        {categories.map((cat) => (
          <tr key={cat.id}>
            <td>
              {cat.image ? (
                <img
                  src={`${baseUrlForFile}/${cat.image}`}
                  alt={cat.name}
                  className="cat-thumb"
                />
              ) : (
                <ImageOff size={20} className="cat-no-image" />
              )}
            </td>

            <td>
              <span className="cat-name">{cat.name}</span>
            </td>

            <td>
              <span className="cat-description">
                {cat.description || "—"}
              </span>
            </td>
              <td>
  <span className="cat-count">
    {cat.type === "product" ? (cat.adproduct_count ?? 0) : (cat.admaterial_count ?? 0)}
  </span>
</td>
            <td>
              <span className={`cat-type-badge ${cat.type}`}>
                {cat.type === "product" ? "Product" : "Inventory"}
              </span>
            </td>

            <td>
              <div className="cat-actions">
                <button
                  className="cat-action-btn cat-edit"
                  onClick={() => setEditId(cat.id)}
                >
                  <Edit2 size={14} />
                </button>

                <button
                  className="cat-action-btn cat-delete"
                  onClick={() =>
                    setDeleteTarget({
                      id: cat.id,
                      name: cat.name,
                    })
                  }
                >
                  <Trash2 size={14} />
                </button>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )}
</div>
      {/* ── Modals ── */}
      {isAddOpen && (
        <AddCategory
          isOpen
          onClose={() => setIsAddOpen(false)}
          triggerRefresh={()=>setRefresh(prev=>!prev)}
          
        />
      )}
      {editId && (
        <EditCategory
          isOpen
          onClose={() => setEditId(null)}
          categoryId={editId}
          category={categories.find((c) => c.id === editId)}
          onEdit={handleEdit}
        />
      )}
      {deleteTarget && (
        <DeleteCategoryConfirmation
          isOpen
          onClose={() => setDeleteTarget(null)}
          onConfirm={handledelete}
          categoryName={deleteTarget.name}
            isDeleting={isDeleting}
        />
      )}
    </div>
  );
};

export default AdminCategoryList;